module.exports = __webpack_public_path__ + "img/maifeld-derby.b95fe1c4.png";